import { render, staticRenderFns } from "./SourcesList.vue?vue&type=template&id=704e361a&scoped=true&"
import script from "./SourcesList.vue?vue&type=script&lang=js&"
export * from "./SourcesList.vue?vue&type=script&lang=js&"
import style0 from "./SourcesList.vue?vue&type=style&index=0&id=704e361a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704e361a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBadge,VCard,VCardTitle,VDataTable,VIcon,VSpacer,VTextField})
